import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class NavbarRestService {
  constructor(private utils: UtilsService, protected http: HttpClient) {}

  getManual(): Observable<any> {
    return this.utils.getBlobFile(`@./assets/files/${environment.manual}`);
  }
}
